export default {
  title: 'Bestelling volgen',
};
